"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPlayPauseOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.play-pause_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "play-pause_outline_svg__transparent_box" },
            React.createElement("path", { className: "play-pause_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "play-pause_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "play-pause_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M24 8v16h7V8zm5 14h-3V10h3zM14 14.31l-13-7v17.36l13-7V24h7V8h-7zm-11 7V10.67L12.9 16zM16 10h3v12h-3V10z" }))));
}
exports.default = SvgPlayPauseOutline;
//# sourceMappingURL=PlayPauseOutline.js.map